import * as React from 'react';
import {LinearLoader} from '@spaced-out/ui-design-system/lib/components/LinearLoader';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import Logo from 'src/images/sense-logo.svg';

import css from './fullscreen-loader.css';


export const FullscreenLoader = ({
  description,
  loaderType = 'linear',
  showLogo = true,
}: {
  description?: React.ReactNode;
  loaderType?: 'linear' | 'circular';
  showLogo?: boolean;
}) => (
  <div className={css.loadingContainer}>
    {showLogo && <Logo className={css.logo} />}
    {loaderType === 'linear' ? (
      <LinearLoader
        className={css.loader}
        value={100}
        size="medium"
        indeterminate
      />
    ) : (
      <CircularLoader
        className={css.circularLoader}
        colorToken="colorFillPrimary"
        size="large"
      />
    )}
    {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
    <div className={css.description}>{description}</div>
  </div>
);
